import "./submit-button.css";

const SubmitButton = ({ loadingState, onClick, successState }) => {
  console.log('successState', successState)
  return (
    <>
    <div className={`submit-wrapper ${loadingState ? 'progress': ''} ${successState ? 'success': ''}`}>
        <a
          className="submit button"
          onClick={onClick}
        >
          提交
        </a>
        <div className="loader-wrapper">
          <span className="loader yellow"></span>
          <span className="loader pink"></span>
        </div>
        <span className="loader orange"></span>
        <div className="check-wrapper">
          <svg version="1.1" viewBox="0 0 24 24">
            <polyline className="check" points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
    </div>

    <svg version="1.1">
      <defs>
        <filter id="goo">
          <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
          <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="goo" />
          <feBlend in="SourceGraphic" in2="goo" />
        </filter>
      </defs>
    </svg>
    </>
  );
};

export default SubmitButton;